import { Select } from "../../../../utils/form";

const LicenseType = ({ form: { control }, ...props }) =>
  <Select control={control} name="licenseType" label="Tipo de Matrícula" list={["nacional", "provincial"]} variant="outlined" required style={{ width: "100%" }} {...props} />

export default LicenseType;
